import React from "react";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { useState } from "react";

const TeamDivisions = () => {
  const consulting = [
    { firstName: "Henry", lastName: "Deng", title: "Data Consultant" },
    { firstName: "Yulian", lastName: "Dlaboha", title: "Data Consultant" },
    { firstName: "George", lastName: "Hanes", title: "Data Consultant" },
    { firstName: "Katie", lastName: "Joh", title: "Data Consultant" },
    { firstName: "Nilan", lastName: "Kathir", title: "Data Consultant" },
    { firstName: "Alexander", lastName: "Ma", title: "Data Consultant" },
    { firstName: "Oliver", lastName: "Meuse", title: "Data Consultant" },
    { firstName: "Saachi", lastName: "Rajgarhia", title: "Data Consultant" },
    { firstName: "Alan", lastName: "Tang", title: "Data Consultant" },
    { firstName: "Laura", lastName: "Taylor", title: "Data Consultant" },
    { firstName: "Matt", lastName: "Ty", title: "Data Consultant" },
    { firstName: "Everett", lastName: "Woo", title: "Data Consultant" },
    { firstName: "Aimee", lastName: "Zhang", title: "Data Consultant" },  
    { firstName: "Eric", lastName: "Wu", title: "Data Consultant" },
  ];
  
  const analytics = [
    { firstName: "Jaden", lastName: "Bobb", title: "Data Scientist" },
    { firstName: "Leo", lastName: "Ledlow", title: "Data Scientist" },
    { firstName: "Bethe", lastName: "Bogrette", title: "Data Scientist" },
    { firstName: "Priscilla", lastName: "Choi", title: "Data Scientist" },
    { firstName: "Max", lastName: "Franceschi", title: "Data Scientist" },
    { firstName: "Artem", lastName: "Gagushin", title: "Data Scientist" },
    { firstName: "Aaron", lastName: "Halder", title: "Data Scientist" },
    { firstName: "Grady", lastName: "Hofeditz", title: "Data Scientist" },
    { firstName: "Yuri", lastName: "Jung", title: "Data Scientist" },
    { firstName: "Sai", lastName: "Kantheti", title: "Data Scientist" },
    { firstName: "Aarju", lastName: "Karki", title: "Data Scientist" },
    { firstName: "Kieran", lastName: "Keiller", title: "Data Scientist" },
    { firstName: "Isabelle", lastName: "Kim", title: "Data Scientist" },
    { firstName: "Katia", lastName: "Kolomiichenko", title: "Data Scientist" },
    { firstName: "Adam", lastName: "Li", title: "Data Scientist" },
    { firstName: "Sam", lastName: "Lim", title: "Data Scientist" },
    { firstName: "Alyssa", lastName: "McGowan", title: "Data Scientist" },
    { firstName: "Siona", lastName: "Misra", title: "Data Scientist" },
    { firstName: "Ogechi", lastName: "Nwankwo", title: "Data Scientist" },
    { firstName: "Jake", lastName: "Park", title: "Data Scientist" },
    { firstName: "Tommy", lastName: "Reichard", title: "Data Scientist" },
    { firstName: "Emory", lastName: "Smith", title: "Data Scientist" },
    { firstName: "Graham", lastName: "Wierzbicki", title: "Data Scientist" },
    { firstName: "Norah", lastName: "Yang", title: "Data Scientist" },

  ];

  const [division, setDivision] = useState(0);
  return (
    <div className="team-divisions">
      <div className="container">
        <h1 className="team-divisions-title">Our Analysts</h1>
        <div className="team-divisions-buttons">
          <div
            className={
              division === 0
                ? "team-divisions-button-active"
                : "team-divisions-button"
            }
            onClick={() => setDivision(0)}>
            <img src="/svgs/divisions/consulting.svg" alt="consulting" />
            <h5>Consulting</h5>
          </div>
          <div
            className={
              division === 1
                ? "team-divisions-button-active"
                : "team-divisions-button"
            }
            onClick={() => setDivision(1)}>
            <img src="/svgs/divisions/analytics.svg" alt="consulting" />
            <h5>Data Science</h5>
          </div>
        </div>
        <div className="team-divisions-members">
          {division === 0 &&
            consulting.map((member, index) => {
              return (
                <AnimationOnScroll
                  animateIn="animate__fadeInUp"
                  animateOnce={true}
                  delay={index * 40}
                  key={member.name}
                  className="team-division-member">
                  <img
                    src={
                      "/headshots-2026/" +
                      member.lastName +
                      ", " +
                      member.firstName +
                      ".jpg"
                    }
                    alt={member.name}
                  />
                  <h2>{member.firstName + " " + member.lastName}</h2>
                  <h3>{member.title}</h3>
                </AnimationOnScroll>
              );
            })}
          {division === 1 &&
            analytics.map((member, index) => {
              return (
                <AnimationOnScroll
                  animateIn="animate__fadeInUp"
                  animateOnce={true}
                  delay={index * 40}
                  key={member.name}
                  className="team-division-member">
                  <img
                    src={
                      "/headshots-2026/" +
                      member.lastName +
                      ", " +
                      member.firstName +
                      ".jpg"
                    }
                    alt={member.name}
                  />
                  <h2>{member.firstName + " " + member.lastName}</h2>
                  <h3>{member.title}</h3>
                </AnimationOnScroll>
              );
            })}

        </div>
      </div>
    </div>
  );
};

export default TeamDivisions;
